<template>
  <div class="writebox" :class="{'product_review_write':product_review}">
    <div class="writeboxcontent clearfix">
      <div class="star row">
        <div class="average-rating">{{Number(average_rating).toFixed(1)}}</div>
        <div class="star__detail">
          <v-comments-star class="col-12" :disabled="true" :average_rating="average_rating"></v-comments-star>
          <span class="secondary_title col-12" style="white-space: nowrap;">{{$t('comment.based_on')}} {{review_count || 0 }} {{$t('comment.reviews')}}</span>
        </div>
      </div>
      <div class="star-bar-box">
        <div class="star-bar-item page_text_font" v-for="(item,index) in rating" :key="index">
          {{5-index}}
          <i class='iconfont icon-cm-jingdiananli_wujiaoxing_shoucanghou' style="color:#ffc124;"></i>
          <span>
            <i :style="'width:' +(item/review_count*100)+'%'"></i>
          </span>
          <em class="page_text_font">({{item}})</em>
        </div>
      </div>
      <div class="write_button secondary_title" @click="write_input_toggle">{{$t('comment.write_a_review')}}</div>
    </div>
    <div class="writeboxcontent m_hidden">
      <div class="athena_review">
           <h3 class="title_font" v-cloak>{{$t('comment.reviews')}}</h3>
           <div class="stars">
            <h3>{{Number(average_rating).toFixed(1)}}</h3>
            <v-comments-star :disabled="true" :average_rating="average_rating"></v-comments-star>
            <span class="review_count">({{review_count || 0 }})</span>
           </div>
      </div>
      <div class="write_button secondary_title" @click="write_input_toggle">{{$t('comment.write_a_review')}}</div>
    </div>
    <v-comments-write-input ref="write_input" :product_id="product_id"></v-comments-write-input>
    <div class="review-ok">
      <h3 class="title_font2">{{$t('comment.thank_you_for_posting_a_review')}}</h3>
      <p class="page_text_font">{{$t('comment.we_value_your_input')}}</p>
      <span class="iconfont icon-cm-cancel-1-copy" @click="$('.review-ok').hide()"></span>
    </div>
  </div>
</template>
<script>
import vCommentsWriteInput from "./commentsWriteInput";
import vCommentsStar from "./commentsstar";
export default {
  props: [
    "review_count",
    "average_rating",
    "rating_count",
    "comments",
    "product_id",
    "product_review",
  ],
  data() {
    return {
      rating: []
    };
  },
  methods: {
    write_input_toggle() {
      this.$refs.write_input.toggle();
      console.log("write_input_toggle");
    }
  },
  beforeMount() {
    if (this.rating_count) {
      this.rating = Object.values(this.rating_count).reverse();
    }
    console.log(this.rating);
    console.log(this.rating_count);
    console.log("pro", this.pro);
  },
  components: {
    vCommentsWriteInput,
    vCommentsStar
  }
};
</script>
<style scoped lang='scss'>
.writebox {
  vertical-align: middle;
  .writeboxcontent {
    padding-bottom: 20px;
    .star {
      // height: 18px;
      display: inline-flex;
      margin: 8px 0;
      text-align: left;
      padding: 0 10px;
      max-width: 300px;
      vertical-align: middle;
      span {
        display: inline-block;
        vertical-align: middle;
        font-size: 16px;
        padding-left: 4px;
        margin-top: 10px;
      }
      .average-rating {
        width: 100%;
        font-size: 60px;
        line-height: 55px;
      }
      &__detail {
        width: 100%;
      }
      &::v-deep {
        .starWrap {
          padding: 0;
        }
      }      
    }
    .star-bar-box {
      display: inline-block;
      vertical-align: middle;
      .star-bar-item {
        display: flex;
        align-items: center;
        font-size: 14px;
        text-align: left;
        line-height: 20px;
        & > i {
          font-size: 18px;
          margin: 0 0 0 8px;
        }
        & > em {
          font-size: 16px;
          font-style: normal;
          color: #666;
          display: inline-block;
          min-width: 30px;
          white-space: nowrap;
        }
        span {
          width: 200px;
          height: 7px;
          background: #f0f2f8;
          display: inline-block;
          margin: 0 10px;
          border-radius: 4px;
          position: relative;
          i {
            width: 0%;
            height: 7px;
            background: #ffc124;
            display: inline-block;
            border-radius: 4px;
            position: absolute;
            left: 0;
            top: 0;
          }
        }
      }
    }
    .write_button {
      float: right;
      cursor: pointer;
      font-size: 14px;
      margin-top: 32px;
      margin-right: 20px;
      border: 1px solid #ddd;
      padding: 12px 20px;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .review-ok {
    font-size: 18px !important;
    margin: 0;
    -webkit-tap-highlight-color: transparent;
    text-align: center;
    padding: 40px 16px;
    background: #fafbff;
    position: relative;
    letter-spacing: 1px;
    display: none;
    span {
      margin: 0;
      padding: 0;
      -webkit-tap-highlight-color: transparent;
      -webkit-font-smoothing: antialiased;
      color: #333;
      cursor: pointer;
      font-size: 20px;
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }
  .m_hidden {
    display: none;
  }
  &.product_review_write {
    .writeboxcontent {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 90px;
      .athena_review {
        display: flex;
        align-items: center;
        text-transform: uppercase;
        h3 {
          font-size: 30px;
          font-family: 'TenorSans';
          margin-right: 20px;
          padding-top: 3px;
        }
        .stars {
          display: flex;
          align-items: center;
          .review_count {
            font-size: 20px;
            padding-left: 10px;
            padding-top: 4px;
          }
        }
        &::v-deep {
          .el-rate {
            height: 30px;
          }
          .el-rate__icon {
            color: #000 !important;
            font-size: 33px !important;
          }
          .el-rate__decimal {
            color: #000 !important;
          }
        }
      }
      .write_button {
        margin: 0;
        font-size: 16px;
        padding: 21px 35px;
        border: 1px solid #222A40;
        font-weight: bold;
        text-align: center;
      }
      &.clearfix {
        display: none !important;
      }
    }
    .athena-reviews {
      display: block;
      padding: 50px 40px;
      background: #F8F8F8;
      margin-bottom: 20px;
      &__rate {
        display: flex;
        align-items: flex-end;
        margin-bottom: 20px;
        &::v-deep {
          .el-rate {
            height: 30px;
          }
          .el-rate__icon {
            color: #000 !important;
            font-size: 33px !important;
          }
          .el-rate__decimal {
            color: #000 !important;
          }
        }
        &__score {
          font-size: 60px;
          line-height: 45px;
          margin-right: 20px;
        }
      }
      &__count {
        font-size: 16px;
      }
    }
    .commentswriteinput  {
      &::v-deep {
        .el-rate__icon {
          color: #000 !important;
        }
        .el-rate__decimal {
          color: #000 !important;
        }
      }
    }
  }
}
@media screen and(max-width: 767px) {
.writebox {
  &.product_review_write {
    .writeboxcontent {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 50px;
      .athena_review {
        display: flex;
        align-items: center;
        text-transform: uppercase;
        width: 100%;
        // justify-content: space-between;
        margin-bottom: 20px;
        margin-top: 10px;
        h3 {
          font-size: 15px;
          margin-right: 10px;
          font-weight: bold;
          padding-top: 0;
        }
        .stars {
          display: flex;
          align-items: center;
          .review_count {
            font-size: 12px;
            padding-left: 5px;
            padding-top: 0;
          }
        }
        &::v-deep {
          .el-rate {
            height: 18px;
          }
          .el-rate__icon {
            color: #000 !important;
            font-size: 18px !important;
          }
        }
      }
      .write_button {
        margin: 0;
        font-size: 14px;
        padding: 15px 36px;
        width: 100%;
      }
    }
    .athena-reviews {
      padding: 25px 20px;
      background: #F8F8F8;
      margin-bottom: 0;
      margin-top: 10px;
      &__rate {
        display: flex;
        align-items: flex-end;
        margin-bottom: 10px;
        &::v-deep {
          .el-rate {
            height: 18px;
          }
          .el-rate__icon {
            font-size: 18px !important;
          }
        }
        &__score {
          font-size: 30px;
          line-height: 25px;
          margin-right: 10px;
        }
      }
      &__count {
        font-size: 14px;
      }
    }
  }
}
}  
@media screen and(max-width: 575px) {
  .writebox {
    .writeboxcontent {
      text-align: center;
      padding-bottom: 0px;

      .star {
        flex-wrap: nowrap;
        align-items: center;
        .average-rating {
          font-size: 50px;
          text-align: center;
        }
        &__detail {
           text-align: left;
        }
        span {
          font-size: 12px;
        }
        &::v-deep {
          .el-rate__icon {
            font-size: 20px !important;
          }
        }
      }
      .star-bar-box{
        .star-bar-item{
          span {
            width: 150px;
          }
        }
      }
      .write_button {
        width: 100%;
        margin: 35px 0;
      }
    }
  }
}
</style>